    <div class="p-3 p-lg-4 app-mgmt-shell">
      <div class="d-flex align-items-center gap-3 app-header mb-3">
        <span class="title-badge">
          <lucide-icon [img]="ClipboardListIcon" [size]="20"></lucide-icon>
        </span>
        <h1 class="m-0 app-title">Application Management</h1>
      </div>

      <div class="pt-3">
        <div class="row g-2 mb-3 stats-row">
          @for (tile of summaryTiles(); track tile.label) {
            <div class="col-12 col-md-6 col-xl">
              <div class="metric-card h-100">
                <div class="metric-head">
                  <div class="metric-title-wrap">
                    <span class="metric-icon-box">
                      <lucide-icon [img]="tile.icon" [size]="16"></lucide-icon>
                    </span>
                    <div class="metric-label">{{ tile.label }}</div>
                  </div>
                  <div class="metric-count">{{ tile.count }}</div>
                </div>
                <div class="metric-sep"></div>
                @for (item of tile.categories; track item.label) {
                  <div
                    class="metric-row"
                    [class.metric-row--clickable]="tile.label === 'Total Applications' || tile.label === 'Auto Suggested' || tile.label === 'Active Contracts'"
                    [class.metric-row--active]="
                      (tile.label === 'Total Applications' && ((item.label === 'Approved' && isStatusFilterActive('approved')) || (item.label === 'Pending' && isStatusFilterActive('pending')) || (item.label === 'Rejected' && isStatusFilterActive('rejected'))))
                      || (tile.label === 'Auto Suggested' && ((item.label === 'Sale Purchase' && isKindFilterActive('salePurchase')) || (item.label === 'Banking' && isKindFilterActive('banking')) || (item.label === 'Hybrid' && isKindFilterActive('hybrid'))))
                    "
                    (click)="
                      tile.label === 'Total Applications'
                        ? applyStatusFilter(item.label === 'Approved' ? 'approved' : item.label === 'Pending' ? 'pending' : 'rejected')
                        : tile.label === 'Auto Suggested'
                          ? applyKindFilter(item.label === 'Sale Purchase' ? 'salePurchase' : item.label === 'Banking' ? 'banking' : 'hybrid')
                          : tile.label === 'Active Contracts'
                            ? openActiveContracts(item.label === 'Sale Purchase' ? 'salePurchase' : item.label === 'Banking' ? 'banking' : 'hybrid')
                          : null
                    "
                  >
                    <div class="metric-category" [class.sale]="item.key === 'sale'" [class.bank]="item.key === 'bank'" [class.hybrid]="item.key === 'hybrid'" [class.success]="item.key === 'success'" [class.warning]="item.key === 'warning'" [class.danger]="item.key === 'danger'" [class.info]="item.key === 'info'">
                      <span>{{ item.label }}</span>
                      <span class="metric-badge">{{ item.count }}</span>
                    </div>
                    <div class="metric-mw">{{ item.mw }} MW</div>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div class="content-card p-3 p-lg-4">
          <div class="list-panel">
            <div class="d-flex flex-column flex-xl-row justify-content-between gap-3 tab-toolbar">
              <div class="chip-list">
                <button type="button" class="chip-btn" [class.active-tab]="activeTab() === 'pendingPunch'" (click)="setActiveTab('pendingPunch')">
                  <lucide-icon [img]="CircleIcon" [size]="14"></lucide-icon>
                  PENDING OA PUNCH
                  <span class="count">{{ pendingPunchCount() }}</span>
                </button>
                <button type="button" class="chip-btn" [class.active-tab]="activeTab() === 'monthlyAdvance'" (click)="setActiveTab('monthlyAdvance')">
                  <lucide-icon [img]="CalendarDaysIcon" [size]="14"></lucide-icon>
                  MONTHLY ADVANCE (NEXT MONTH)
                  <span class="count dark">{{ monthlyAdvanceCount() }}</span>
                </button>
                <button type="button" class="chip-btn" [class.active-tab]="activeTab() === 'all'" (click)="setActiveTab('all')">
                  <lucide-icon [img]="FileTextIcon" [size]="14"></lucide-icon>
                  ALL APPLICATIONS
                </button>
              </div>
              <div class="toolbar-right">
                <button class="btn-light-outline" type="button" (click)="toggleFilters()">
                  FILTERS
                  <lucide-icon class="ms-1" [img]="FilterIcon" [size]="14"></lucide-icon>
                </button>
                <button class="btn-green" type="button" (click)="exportApplications()" title="Export current list">
                  <lucide-icon [img]="DownloadIcon" [size]="16"></lucide-icon>
                </button>
                <a class="btn-create text-decoration-none d-inline-flex align-items-center gap-2" href="/applications/new">
                  <span class="plus-ring"><lucide-icon [img]="PlusIcon" [size]="12"></lucide-icon></span>
                  <span>ADD APPLICATION</span>
                </a>
              </div>
            </div>

            @if (showFilters()) {
              <div class="filter-panel">
                <div class="filter-grid">
                  <div class="filter-field filter-field--search">
                    <label>Search</label>
                    <input
                      class="form-control"
                      type="text"
                      [value]="searchTerm()"
                      (input)="updateSearchTerm(($any($event.target).value || '').toString())"
                      [placeholder]="activeTab() === 'pendingPunch' ? 'Search contract, buyer, seller, application no.' : 'Search application, contract, buyer, seller'"
                    />
                  </div>

                  @if (activeTab() !== 'pendingPunch') {
                    <div class="filter-field">
                      <label>Status</label>
                      <select class="form-select" [value]="statusFilter()" (change)="updateStatusFilter(($any($event.target).value || 'all').toString())">
                        <option value="all">All</option>
                        <option value="approved">Approved</option>
                        <option value="pending">Pending</option>
                        <option value="rejected">Rejected</option>
                      </select>
                    </div>

                    <div class="filter-field">
                      <label>Application Type</label>
                      <select class="form-select" [value]="applicationTypeFilter()" (change)="updateApplicationTypeFilter(($any($event.target).value || 'all').toString())">
                        @for (item of applicationTypeOptions; track item) {
                          <option [value]="item">{{ item === 'all' ? 'All Types' : item }}</option>
                        }
                      </select>
                    </div>

                    <div class="filter-field">
                      <label>From Date</label>
                      <input class="form-control" type="date" [value]="fromDateFilter()" (input)="updateFromDateFilter(($any($event.target).value || '').toString())" />
                    </div>

                    <div class="filter-field">
                      <label>To Date</label>
                      <input class="form-control" type="date" [value]="toDateFilter()" (input)="updateToDateFilter(($any($event.target).value || '').toString())" />
                    </div>
                  } @else {
                    <div class="filter-field">
                      <label>Contract Kind</label>
                      <select class="form-select" [value]="pendingPunchKindFilter()" (change)="updatePendingPunchKindFilter(($any($event.target).value || 'all').toString())">
                        <option value="all">All</option>
                        <option value="salePurchase">Sale Purchase</option>
                        <option value="banking">Banking</option>
                        <option value="hybrid">Hybrid</option>
                      </select>
                    </div>
                  }

                  <div class="filter-actions">
                    <button class="btn btn-outline-secondary" type="button" [disabled]="!hasActiveFilters()" (click)="clearAllFilters()">Clear Filters</button>
                  </div>
                </div>
              </div>
            }

            @if (activeTab() === 'pendingPunch') {
              <div class="alert alert-danger mb-2">
                <div class="fw-bold">Current Month Active Contracts Requiring OA Applications</div>
                <div>{{ displayPendingPunchCount() }} contracts with {{ displayPendingPunchTotalQuantum() }} MWh pending OA punch</div>
              </div>
              <div class="table-wrap">
                <div class="table-responsive app-table-scroll" style="max-height: 500px; overflow-y: auto;">
                  <table class="table app-table app-table-wide mb-0">
                    <thead class="sticky-top">
                      <tr>
                        <th>S. No.</th>
                        <th>Contract No.</th>
                        <th>Seller</th>
                        <th>Buyer</th>
                        <th>Type</th>
                        <th>Application Count</th>
                        <th>Period</th>
                        <th>Quantum</th>
                        <th>Already Scheduled</th>
                        <th>Remaining to Punch</th>
                        <th>Route Details</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      @if (displayPendingPunchRows().length === 0) {
                        <tr><td colspan="12" class="text-center text-muted py-4">No contracts pending OA punch</td></tr>
                      }
                      @for (row of pagedDisplayPendingPunchRows(); track row.contractId; let index = $index) {
                        <tr>
                          <td>{{ pageStartIndex() + index + 1 }}</td>
                          <td>{{ row.contractNo }}</td>
                          <td>
                            @for (party of row.sellerParties; track party.vendorId + party.name) {
                              <div>
                                @if (party.vendorId) {
                                  <button class="party-link" type="button" (click)="openVendorDetails(party.vendorId)">{{ party.name }}</button>
                                } @else {
                                  {{ party.name }}
                                }
                              </div>
                            }
                          </td>
                          <td>
                            @for (party of row.buyerParties; track party.vendorId + party.name) {
                              <div>
                                @if (party.vendorId) {
                                  <button class="party-link" type="button" (click)="openVendorDetails(party.vendorId)">{{ party.name }}</button>
                                } @else {
                                  {{ party.name }}
                                }
                              </div>
                            }
                          </td>
                          <td>{{ row.type }}</td>
                          <td>
                            <div class="app-count-tooltip-wrap" tabindex="0">
                              <span class="app-count-badge">{{ row.applicationCount }}</span>
                              <div class="app-count-tooltip">
                                <div class="app-count-tooltip-title">Application Numbers</div>
                                @if (row.applicationNumbers.length) {
                                  @for (appNo of row.applicationNumbers; track appNo) {
                                    <div class="app-count-tooltip-line">{{ appNo }}</div>
                                  }
                                } @else {
                                  <div class="app-count-tooltip-line">No applications</div>
                                }
                              </div>
                            </div>
                          </td>
                          <td>{{ row.period }}</td>
                          <td>{{ row.quantum }} MWh</td>
                          <td>{{ row.alreadyScheduled }} MWh</td>
                          <td><span class="badge text-bg-primary">{{ row.remainingToPunch }} MWh</span></td>
                          <td>Injection: -<br />Drawal: -<br />SLDC: -<br />RLDC: -</td>
                          <td>
                            <a class="btn btn-sm btn-primary" [routerLink]="'/applications/new'" [queryParams]="{ contractId: row.contractId, remainingQuantum: row.remainingToPunch }">PUNCH OA</a>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            } @else {
              <div class="alert alert-primary mb-2">
                <div class="fw-bold">Current Month Active Contracts Requiring OA Applications</div>
                <div>
                  @if (activeTab() === 'monthlyAdvance') {
                    {{ monthlyAdvanceRecords().length }} contracts with {{ monthlyAdvanceQuantum() }} MWh pending OA punch
                  } @else {
                    {{ displayRecords().length }} applications with {{ displayQuantum() }} MWh
                  }
                </div>
              </div>
              <div class="table-wrap">
                <div class="table-responsive" style="max-height: 500px; overflow-y: auto;">
                  <table class="table app-table mb-0">
                    <thead class="sticky-top">
                      <tr>
                        <th>S. No.</th>
                        <th>Application No.</th>
                        <th>Contract No.</th>
                        <th>Application Type</th>
                        <th>Seller</th>
                        <th>Seller SLDC</th>
                        <th>Seller RLDC</th>
                        <th>Buyer</th>
                        <th>Buyer SLDC</th>
                        <th>Buyer RLDC</th>
                        <th>Quantum (MWh)</th>
                        <th>Corridor</th>
                        <th>Valid From</th>
                        <th>Valid To</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      @if (displayRecords().length === 0) {
                        <tr><td colspan="16" class="text-center text-muted py-4">{{ activeTab() === 'monthlyAdvance' ? 'No contracts available for next month' : 'No records found' }}</td></tr>
                      }
                      @for (record of pagedDisplayRecords(); track record.id; let index = $index) {
                        <tr>
                          <td>{{ pageStartIndex() + index + 1 }}</td>
                          <td>{{ record.appNo }}</td>
                          <td>{{ record.contractNo }}</td>
                          <td><span class="type-pill">{{ record.appType }}</span></td>
                          <td>
                            @if (record.sellerVendorId) {
                              <button class="party-link" type="button" (click)="openVendorDetails(record.sellerVendorId)">{{ record.seller }}</button>
                            } @else {
                              {{ record.seller }}
                            }
                          </td>
                          <td>{{ record.sellerSldc }}</td>
                          <td>{{ record.sellerRldc }}</td>
                          <td>
                            @if (record.buyerVendorId) {
                              <button class="party-link" type="button" (click)="openVendorDetails(record.buyerVendorId)">{{ record.buyer }}</button>
                            } @else {
                              {{ record.buyer }}
                            }
                          </td>
                          <td>{{ record.buyerSldc }}</td>
                          <td>{{ record.buyerRldc }}</td>
                          <td>{{ record.quantum }}</td>
                          <td>
                            @for (path of record.corridor; track path) {
                              <span class="corridor-pill">{{ path }}</span>
                            }
                          </td>
                          <td>{{ record.validFrom }}</td>
                          <td>{{ record.validTo }}</td>
                          <td>
                            <span class="status-pill" [class.pending]="record.status === 'pending'" [class.approved]="record.status === 'approved'" [class.rejected]="record.status === 'rejected'" [class.punched]="record.status === 'punched'">
                              <lucide-icon [img]="Clock3Icon" [size]="13"></lucide-icon>
                              {{ record.status | titlecase }}
                            </span>
                          </td>
                          <td>
                            <button class="icon-action" type="button" (click)="downloadFormatD(record)">
                              <lucide-icon [img]="DownloadIcon" [size]="15"></lucide-icon>
                            </button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }

            <div class="pager-row mt-3">
              <div class="pager-meta">{{ pageStart() }}-{{ pageEnd() }} of {{ totalRows() }} {{ activeTab() === 'pendingPunch' ? 'contracts' : 'applications' }}</div>
              <div class="pagination-shell">
                <button class="pager-btn" type="button" [disabled]="!canGoToPreviousPage()" (click)="currentPage.set(1)" aria-label="First page">
                  <lucide-icon [img]="ChevronsLeftIcon" [size]="14"></lucide-icon>
                </button>
                <button class="pager-btn" type="button" [disabled]="!canGoToPreviousPage()" (click)="goToPreviousPage()" aria-label="Previous page">
                  <lucide-icon [img]="ChevronLeftIcon" [size]="14"></lucide-icon>
                </button>
                <span class="page-indicator current">{{ currentPageSafe() }}</span>
                <button class="pager-btn" type="button" [disabled]="!canGoToNextPage()" (click)="goToNextPage()" aria-label="Next page">
                  <lucide-icon [img]="ChevronRightIcon" [size]="14"></lucide-icon>
                </button>
                <button class="pager-btn" type="button" [disabled]="!canGoToNextPage()" (click)="currentPage.set(totalPages())" aria-label="Last page">
                  <lucide-icon [img]="ChevronsRightIcon" [size]="14"></lucide-icon>
                </button>
                <select class="form-select form-select-sm page-size-select pager-size-select" [value]="pageSize()" (change)="onPageSizeChange(($any($event.target).value || '10').toString())" aria-label="Rows per page">
                @for (size of pageSizes; track size) {
                  <option [value]="size">{{ size }}/Page</option>
                }
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
